import { render, staticRenderFns } from "./StarRatingView.vue?vue&type=template&id=6ea26795&scoped=true&"
import script from "./StarRatingView.vue?vue&type=script&lang=js&"
export * from "./StarRatingView.vue?vue&type=script&lang=js&"
import style0 from "./StarRatingView.vue?vue&type=style&index=0&id=6ea26795&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea26795",
  null
  
)

export default component.exports